import timg1 from '../images/team/img-1.jpg'
import timg2 from '../images/team/img-2.jpg'
import timg3 from '../images/team/img-3.jpg'
import timg4 from '../images/team/img-4.jpg'


const Teams = [
    {
        Id: '1',
        tImg:timg1,
        name:'Ahmed Hassan',
        title:'Chief Executive Officer',
        bio:'Leading Giga Group with 25+ years of experience in real estate development across Pakistan and UAE.',
        experience:'25 Years',
        email:'ahmed.hassan@gigagroup.com',
        phone:'+971 4 123 4567'
    },
    {
        Id: '2',
        tImg:timg2,
        name:'Sarah Khan',
        title:'Senior Architect',
        bio:'Award-winning architect specializing in luxury residential and commercial developments.',
        experience:'18 Years',
        email:'sarah.khan@gigagroup.com',
        phone:'+971 4 123 4568'
    },
    {
        Id: '3',
        tImg:timg3,
        name:'Mohammad Ali',
        title:'Project Director',
        bio:'Overseeing major construction projects with expertise in sustainable building practices.',
        experience:'20 Years',
        email:'mohammad.ali@gigagroup.com',
        phone:'+971 4 123 4569'
    },
    {
        Id: '4',
        tImg:timg4,
        name:'Fatima Sheikh',
        title:'Design Director',
        bio:'Creative visionary responsible for interior design and aesthetic excellence in all projects.',
        experience:'15 Years',
        email:'fatima.sheikh@gigagroup.com',
        phone:'+971 4 123 4570'
    },
    {
        Id: '5',
        tImg:timg1,
        name:'Omar Farooq',
        title:'Construction Manager',
        bio:'Ensuring quality construction delivery with focus on safety and efficiency.',
        experience:'12 Years',
        email:'omar.farooq@gigagroup.com',
        phone:'+971 4 123 4571'
    },
    {
        Id: '6',
        tImg:timg2,
        name:'Aisha Malik',
        title:'Business Development Manager',
        bio:'Driving growth and strategic partnerships in the real estate sector.',
        experience:'10 Years',
        email:'aisha.malik@gigagroup.com',
        phone:'+971 4 123 4572'
    },
    {
        Id: '7',
        tImg:timg3,
        name:'Hassan Raza',
        title:'Senior Engineer',
        bio:'Structural engineering expert with specialization in high-rise buildings.',
        experience:'14 Years',
        email:'hassan.raza@gigagroup.com',
        phone:'+971 4 123 4573'
    },
    {
        Id: '8',
        tImg:timg4,
        name:'Zara Ahmed',
        title:'Marketing Director',
        bio:'Leading brand strategy and marketing initiatives for Giga Group projects.',
        experience:'8 Years',
        email:'zara.ahmed@gigagroup.com',
        phone:'+971 4 123 4574'
    }
]

export default Teams;